import { Space, Button, Card } from 'antd';
import { useLanguage } from '../utils/LanguageContext';
import translations from '../components/ComponentsTranslations.lang.json';
import { useAuth } from '../utils/AuthContext';
import { useRefreshingAsync } from './common/commonHooks';

const AccountStatements = ({ investmentAccountId }) => {
  const { lang } = useLanguage(translations);
  const { api } = useAuth();

  const statements = useRefreshingAsync(async () => await api.getInvestmentAccountStatements(investmentAccountId));

  return (
    statements && (
      <Card title={lang('yourStatements')}>
        {statements.length > 0 ? (
          statements.map((statement) => (
            <div key={statement.documentId}>
              <p>
                {lang('statementDate')}: {statement.date}
              </p>
              <div>
                <Space.Compact style={{ width: '100%' }}>
                  <Button
                    type="primary"
                    onClick={() => api.downloadInvestmentAccountStatement(investmentAccountId, statement.documentId)}
                  >
                    {lang('download')}
                  </Button>
                </Space.Compact>
              </div>
            </div>
          ))
        ) : (
          <p>{lang('noStatementsMessage')}</p>
        )}
      </Card>
    )
  );
};

const Statements = () => {
  const { api } = useAuth();

  const investmentAccounts = useRefreshingAsync(api.getInvestmentAccounts);

  return (
    investmentAccounts &&
    investmentAccounts.map(({ investmentAccountId }, i) => (
      <AccountStatements key={i} investmentAccountId={investmentAccountId} />
    ))
  );
};

export default Statements;
